import { render, staticRenderFns } from "./MStoreTable.vue?vue&type=template&id=12dccef9&scoped=true&"
import script from "./MStoreTable.vue?vue&type=script&lang=ts&"
export * from "./MStoreTable.vue?vue&type=script&lang=ts&"
import style0 from "./MStoreTable.vue?vue&type=style&index=0&id=12dccef9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dccef9",
  null
  
)

export default component.exports